import type { IconNode } from '../types';

/**
 * @name trousers
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNNCA2aDE2IiAvPgogIDxwYXRoIGQ9Ik02IDIyYTIgMiAwIDAgMS0yLTJWM2MwLS42LjQtMSAxLTFoMTRjLjYgMCAxIC40IDEgMXYxN2EyIDIgMCAwIDEtMiAyaC0zbC0zLTEwLTMgMTBaIiAvPgogIDxwYXRoIGQ9Im02IDExLTIgMSIgLz4KICA8cGF0aCBkPSJNOSA4LjVWNiIgLz4KICA8cGF0aCBkPSJNMTUgNnYyLjUiIC8+CiAgPHBhdGggZD0ibTIwIDEyLTItMSIgLz4KICA8cGF0aCBkPSJNNCAxOGg2IiAvPgogIDxwYXRoIGQ9Ik0xNCAxOGg2IiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/trousers
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const trousers: IconNode = [
  ['path', { d: 'M4 6h16', key: '1o0s65' }],
  [
    'path',
    {
      d: 'M6 22a2 2 0 0 1-2-2V3c0-.6.4-1 1-1h14c.6 0 1 .4 1 1v17a2 2 0 0 1-2 2h-3l-3-10-3 10Z',
      key: '1rdpth',
    },
  ],
  ['path', { d: 'm6 11-2 1', key: 'wg0633' }],
  ['path', { d: 'M9 8.5V6', key: '195be6' }],
  ['path', { d: 'M15 6v2.5', key: 'c1bjdm' }],
  ['path', { d: 'm20 12-2-1', key: '1sfjm0' }],
  ['path', { d: 'M4 18h6', key: '1jikk7' }],
  ['path', { d: 'M14 18h6', key: '1m8k6r' }],
];

export default trousers;
